export enum UiFooterType {
  DEFAULT = 'default',
  ROW = 'row',
}
